import { createApp } from 'vue'
import BasicModal from '@/components/BasicModal.vue'
import { subscribe } from '@/services/klaviyo'

const SPECIAL_KEYS = ['$email', '$phone_number', '$source', '$list_id']

export default function () {
  const forms = document.querySelectorAll('[data-klaviyo-signup-form]')

  forms.forEach((form: Element) => {
    const formElement = form as HTMLFormElement
    form.addEventListener('submit', (e) => {
      e.preventDefault()
      if (!formElement.checkValidity()) return
      const formData = new FormData(formElement)
      const formObj: Record<string, FormDataEntryValue | FormDataEntryValue[]> =
        Object.fromEntries(formData)

      subscribe({
        list_id: formObj.$list_id as string,
        custom_source: formObj.$source as string,
        email: formObj.$email as string,
        phone_number: formObj.$phone_number
          ? formObj.$phone_number
              .toString()
              .replace(/^0/, '+44')
              .replace(/\s/, '')
          : undefined,
        properties: {
          ...Object.keys(formObj).reduce(
            (accum, key) => {
              if (SPECIAL_KEYS.includes(key)) return accum
              accum[key] = formObj[key]
              return accum
            },
            {} as Record<string, FormDataEntryValue | FormDataEntryValue[]>,
          ),
          $consent: ['email', 'sms'],
        },
      })
        .then((res) => {
          if (res.status === 202) {
            showSuccessModal()
          } else {
            showErrorModal()
          }
        })
        .catch((e) => {
          showErrorModal()
          window.Bugsnag.notify(e)
          console.log(e)
        })
    })
  })

  const showSuccessModal = () => {
    const app = createApp(BasicModal, {
      content: document.querySelector('[data-klaviyo-signup-modal-success]')
        ?.innerHTML,
    })
    app.mount('#modal-container')
  }

  const showErrorModal = () => {
    const app = createApp(BasicModal, {
      content: document.querySelector('[data-klaviyo-signup-modal-error]')
        ?.innerHTML,
    })
    app.mount('#modal-container')
  }
}
